import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-banner',
  templateUrl: './faq-banner.component.html',
  styleUrls: ['./faq-banner.component.css']
})
export class FaqBannerComponent implements OnInit {
  @Input() title: string;

  constructor() { }

  ngOnInit(): void {
  }
}
